import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import "./PhilosophySection.css";
import { useNavigate } from "react-router-dom";

const PhilosophySection = () => {
  const navigate = useNavigate();
  const handleButtonClick = () => {
    navigate("/services");
  };
  return (
    <section className="philosophy-section ">
      <Container className="">
        <Row className="align-items-center g-4">
          <Col md={5} className="">
            <h2 className="philosophy-title">Because Every Eye Deserves the Best</h2>
            <p className="philosophy-text">
              We believe your eyes deserve more than just care. They deserve attention, precision and style. Our mission is to provide expert vision solutions while helping you express yourself through eyewear that complements your personality.
            </p>
            <button className="visit-btn" onClick={handleButtonClick}>Our Services</button>
          </Col>
          <Col md={7}>
            <div className="vision-image-wrap">
              <img src={"/services-hero.png"} alt="Luxury eyewear" className="img-fluid vision-image " />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default PhilosophySection;
